import { os } from '@ali/amap-lib';

let scrollTop = 0;
let set = [];


let iOS10Fixed = os.ios;

const pageScrollCtrl = {
  /**
   * 锁定模块
   * @param {string} name - 需要锁定的模块名称
   */
  lock(name) {
    if (!set.length) {
      scrollTop = document.documentElement.scrollTop
        || window.pageYOffset
        || document.body.scrollTop;
      document.body.style.position = 'fixed';
      document.body.style.top = `${-scrollTop}px`;
      const titleBar = document.getElementById('titleBar');
      if (iOS10Fixed && titleBar) {
        titleBar.style.position= 'absolute';
        titleBar.style.top= `${scrollTop}px`;
      }
    }
    set.push(name);
  },
  /**
   * 锁定模块
   * @param {string} name - 需要锁定的模块名称
   */
  unlock(name) {
    let i = set.indexOf(name);
    if (i > -1) {
      set.splice(i, 1);
    }

    if (!set.length) {
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, scrollTop); // 回到原先的top
      const titleBar = document.getElementById('titleBar');
      if (iOS10Fixed && titleBar) {
        titleBar.style.position= '';
        titleBar.style.top= `${0}px`;
      }
    }
  }
};

export default pageScrollCtrl;

